// mutations of the state happens here
import types from './mutation-types'

export default {
  [types.FETCH_USERS](state, value) {
    state.isFetchingUsers = value
  },
  [types.LOAD_USERS_DATA](state, userData) {
    state.pagination = userData.pagination
    state.userData = userData.data
  },
  [types.UPDATE_PARAMS](state, newParams) {
    // here object assign is used to merge values from newParams into filterParams
    // if key exists in filterParams, newParams overwrite with new value
    // if key does not exist, value will not be updated
    // this is handy for pagination where for instance &per_page=10 should exist on
    // all calls. This way we won't need to send pagination when updating &query= for instance
    Object.assign(state.filterParams, newParams)
  },
}
